export default {"src":"/_next/static/media/graphql.3a7e3927.svg","height":288,"width":256,"blurWidth":0,"blurHeight":0};